(() => {
  if (!/^fi(?:-|$)/i.test(document.documentElement.lang)) return;

  const watchedWidgets = new WeakSet();
  const widgetSelector = '#judgeme_product_reviews.jdgm-widget';

  const updateLabels = (widget) => {
    widget.querySelectorAll('.jm-average-rating-display__review-count').forEach((label) => {
      const match = label.textContent.trim().match(/^(\d[\d\s.,]*)\s+arvostelut$/u);
      if (!match) return;
      const word = match[1].replace(/\s/g, '') === '1' ? 'arvostelu' : 'arvostelua';
      label.textContent = match[1] + ' ' + word;
    });
    widget.querySelectorAll('button.jm-review-highlights__row .jdgm-visually-hidden').forEach((label) => {
      if (label.textContent.trim() === 'More') label.textContent = 'Näytä lisää';
    });
  };

  const watchWidget = (widget) => {
    if (watchedWidgets.has(widget)) return;
    watchedWidgets.add(widget);
    updateLabels(widget);
    let pending = false;
    const observer = new MutationObserver(() => {
      if (!widget.isConnected) {
        observer.disconnect();
        return;
      }
      if (pending) return;
      pending = true;
      queueMicrotask(() => {
        pending = false;
        updateLabels(widget);
      });
    });
    observer.observe(widget, { childList: true, subtree: true, characterData: true });
  };

  const findWidgets = (root) => {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.matches?.(widgetSelector)) watchWidget(root);
    root.querySelectorAll(widgetSelector).forEach(watchWidget);
  };

  const start = () => {
    const main = document.getElementById('MainContent');
    findWidgets(document);
    if (!main) return;
    const discovery = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach(findWidgets));
    });
    discovery.observe(main, { childList: true, subtree: true });
    setTimeout(() => discovery.disconnect(), 60000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', (event) => findWidgets(event.target));
  window.addEventListener('load', () => findWidgets(document), { once: true });
})();
